import { render, staticRenderFns } from "./SBNotifications.vue?vue&type=template&id=ae61ccf0"
import script from "./SBNotifications.vue?vue&type=script&lang=js"
export * from "./SBNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports